import Box from '@mui/material/Box'

const PageSectionGrid = ({ columns = 2, children }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: `repeat(${columns}, 1fr)` },
        gap: 2,
      }}
    >
      {children}
    </Box>
  )
}

export default PageSectionGrid
